module.exports = __webpack_public_path__ + "img/circle_exclamation_mark (2).30cfe982.svg";